import crudder from 'tools/crudder'

const API_URL = process.env.PUBLIC_URL
const API_PATH = '/api'

const errorHandler = apiResponse => {
  if (apiResponse?.error && apiResponse?.error?.length !== 0) {
    throw apiResponse
  } else {
    return apiResponse
  }
}

const getTickets = async (options = { done: false }) => {
  const pathTickets = `${API_PATH}/tickets${options.done ? '/history' : ''}`

  const apiTickets = crudder(API_URL)
  const search = apiTickets(pathTickets)

  return search.get()
    .then(errorHandler)
}

export default getTickets
